import React from 'react';
import { Pagination } from 'react-bootstrap';
var xs = { padding: '.1rem .1rem .1rem .1rem', margin: '0 0 0 0', fontSize: '.75rem' };
export default function PaginacionXS(p) {
    if (p.length === 0)
        return React.createElement(React.Fragment, null);
    var setpage = p.setpage, length = p.length, mostrar = p.mostrar, page = p.page, total_page = Math.ceil(length / mostrar), buttons = [];
    if (page === 1) {
        buttons.push(React.createElement(Iten, { key: 'active1', active: true, page: 1 }));
    }
    else {
        buttons.push(React.createElement(Iten, { key: 'p1', click: setpage.bind(p, 1), page: 1 }));
    }
    for (var i = 3; i > 0; i--) {
        if (page - i > 1) {
            if (i === 3) {
                buttons.push(React.createElement(Pagination.Ellipsis, { style: xs, key: 'Ellipsis1' }));
            }
            else {
                buttons.push(React.createElement(Iten, { key: 'active' + (page - 1), click: setpage.bind(p, page - i), page: page - 1 }));
            }
        }
    }
    if (total_page > page && page > 1) {
        buttons.push(React.createElement(Iten, { key: 'active' + page, active: true, page: page }));
    }
    for (var i = 1; i < 4; i++) {
        if (page + i < total_page) {
            if (i === 3) {
                buttons.push(React.createElement(Pagination.Ellipsis, { style: xs, key: 'Ellipsis2' }));
            }
            else {
                buttons.push(React.createElement(Iten, { key: 'active' + (page + i), click: setpage.bind(p, page + i), page: page + i }));
            }
        }
    }
    if (page === total_page) {
        if (1 < total_page) {
            buttons.push(React.createElement(Iten, { key: 'active' + total_page, active: true, page: total_page }));
        }
    }
    else {
        buttons.push(React.createElement(Iten, { key: 'p' + total_page, click: setpage.bind(p, total_page), page: total_page }));
    }
    return React.createElement(Pagination, { style: { position: 'relative', float: 'right' } }, buttons);
}
function Iten(_a) {
    var page = _a.page, active = _a.active, click = _a.click;
    return (React.createElement(Pagination.Item, { active: active, onClick: click, style: xs }, page));
}
//# sourceMappingURL=PaginacionXS.js.map